import Auth from '@/mixins/auth'
import KdsOrderStatusEnum from '@/api/Enums/KdsOrderStatusEnum.js'
import KdsOrderItemStatusEnum from '@/api/Enums/KdsOrderItemStatusEnum.js'

export default {
  dataStore: {
    kdsOrders: 'kds.Orders'
  },

  mixins: [Auth],

  computed: {},

  methods: {
    getKdsOrderItemStatus(item) {
      const items = Object.values(this.$t('Kds.Status.Item'))
      return items.find(i => i.Code === item?.Status) || {}
    },

    loadingCompleteKdsOrder(order) {
      return !!order?.kdsOrderCompleteLoading
    },
    canCompleteKdsOrder(order) {
      return ![KdsOrderStatusEnum.COMPLETE, KdsOrderStatusEnum.CANCEL].includes(order?.Status)
    },

    loadingRevertKdsOrder(order) {
      return !!order?.kdsOrderRevertLoading
    },
    canRevertKdsOrder(order) {
      return [KdsOrderStatusEnum.COMPLETE, KdsOrderStatusEnum.CANCEL].includes(order?.Status)
    },

    loadingHoldKdsOrder(order) {
      return !!order?.kdsOrderHoldLoading
    },
    canHoldKdsOrder(order) {
      return [KdsOrderStatusEnum.OPEN].includes(order?.Status)
    },

    loadingResumeKdsOrder(order) {
      return !!order?.kdsOrderResumeLoading
    },
    canResumeKdsOrder(order) {
      return [KdsOrderStatusEnum.HOLD].includes(order?.Status)
    },

    loadingMoveForwardKdsOrder(order) {
      return !!order?.kdsOrderMoveForwardLoading
    },
    canMoveForwardKdsOrder(order) {
      return [KdsOrderStatusEnum.OPEN, KdsOrderStatusEnum.HOLD].includes(order?.Status)
    },

    loadingMoveBackwardKdsOrder(order) {
      return !!order?.kdsOrderMoveBackwardLoading
    },
    canMoveBackwardKdsOrder(order) {
      return [KdsOrderStatusEnum.OPEN, KdsOrderStatusEnum.HOLD].includes(order?.Status)
    },

    loadingMoveFirstKdsOrder(order) {
      return !!order?.kdsOrderMoveFirstLoading
    },
    canMoveFirstKdsOrder(order) {
      return [KdsOrderStatusEnum.OPEN, KdsOrderStatusEnum.HOLD].includes(order?.Status)
    },

    loadingMoveLastKdsOrder(order) {
      return !!order?.kdsOrderMoveLastLoading
    },
    canMoveLastKdsOrder(order) {
      return [KdsOrderStatusEnum.OPEN, KdsOrderStatusEnum.HOLD].includes(order?.Status)
    },


    loadingStartKdsOrderItem(item) {
      return !!item?.kdsOrderItemStartLoading
    },
    canStartKdsOrderItem(item) {
      return [KdsOrderItemStatusEnum.OPEN, KdsOrderItemStatusEnum.HOLD].includes(item?.Status)
    },

    loadingHoldKdsOrderItem(item) {
      return !!item?.kdsOrderItemHoldLoading
    },
    canHoldKdsOrderItem(item) {
      return [KdsOrderItemStatusEnum.OPEN, KdsOrderItemStatusEnum.START].includes(item?.Status)
    },

    loadingRevertKdsOrderItem(item) {
      return !!item?.kdsOrderItemRevertLoading
    },
    canRevertKdsOrderItem(item) {
      return [KdsOrderItemStatusEnum.COMPLETE, KdsOrderItemStatusEnum.CANCEL].includes(item?.Status)
    },

    loadingCompleteKdsOrderItem(item) {
      return !!item?.kdsOrderItemCompleteLoading
    },
    canCompleteKdsOrderItem(item) {
      return [KdsOrderItemStatusEnum.OPEN, KdsOrderItemStatusEnum.START, KdsOrderItemStatusEnum.HOLD].includes(item?.Status)
    }
  }
}
